import {Dce, DceComponent, DceHTMLElement} from "dce-engine";

interface PreviewProps {

}

const breakpoints = {
    'xs' : 420,
    'sm' : 576,
    'md' : 768,
    'lg' : 992,
    'xl' : 1200,
    'xxl':  1400,
}

@Dce("Preview")
export default class Preview extends DceComponent<PreviewProps> {
    private iframe: HTMLIFrameElement;


    constructor(elem: DceHTMLElement, props: PreviewProps) {
        super(elem, props);

        this.iframe = elem.querySelector('iframe');

        let dim = elem.dataset.dim.split(',');

        console.log(dim);

        let toolbar = document.createElement('div');
        toolbar.classList.add('preview--toolbar');

        elem.prepend(toolbar);

        dim.map(d => {
            let b = document.createElement('button');
            b.classList.add('preview--button');

            let width: number = 0;
            if(breakpoints.hasOwnProperty(d)){
                b.innerHTML = d + '(' + breakpoints[d] + 'px)';
                width = breakpoints[d];
            }else{
                width = parseInt(d);
                b.innerHTML = '(' + width + 'px)';
            }

            if(width) {
                toolbar.append(b);

                b.addEventListener('click', e => {

                    this.iframe.style.width = width + 'px';
                    toolbar.querySelectorAll('.preview--button.preview--button--active')
                        .forEach(b => b.classList.remove('preview--button--active'));
                    b.classList.add('preview--button--active');



                })
            }


        });


    }

}
